import { render, staticRenderFns } from "./SelectDoctorList.vue?vue&type=template&id=1d96b082&"
import script from "./SelectDoctorList.vue?vue&type=script&lang=js&"
export * from "./SelectDoctorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports